import React from 'react'

export default ({ fillColor }) => (
	<svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="90"
      height="90"
      viewBox="0 0 90 90"
    >
      <defs>
        <filter
          id="filter-1"
          width="133.3%"
          height="133.3%"
          x="-16.7%"
          y="-16.7%"
          filterUnits="objectBoundingBox"
        >
          <feOffset
            dy="2"
            in="SourceAlpha"
            result="shadowOffsetOuter1"
          ></feOffset>
          <feGaussianBlur
            in="shadowOffsetOuter1"
            result="shadowBlurOuter1"
            stdDeviation="2"
          ></feGaussianBlur>
          <feColorMatrix
            in="shadowBlurOuter1"
            result="shadowMatrixOuter1"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          ></feColorMatrix>
          <feMerge>
            <feMergeNode in="shadowMatrixOuter1"></feMergeNode>
            <feMergeNode in="SourceGraphic"></feMergeNode>
          </feMerge>
        </filter>
        <rect id="path-2" width="72" height="72" x="0" y="0" rx="10.686"></rect>
        <linearGradient
          id="linearGradient-4"
          x1="50%"
          x2="50%"
          y1="0%"
          y2="100%"
        >
          <stop offset="0%" stopColor="#1F3285"></stop>
          <stop offset="100%" stopColor="#1F2F72"></stop>
        </linearGradient>
        <linearGradient
          id="linearGradient-5"
          x1="50%"
          x2="50%"
          y1="0%"
          y2="100%"
        >
          <stop offset="0%" stopColor="#1F2E6A"></stop>
          <stop offset="100%" stopColor="#1E294C"></stop>
        </linearGradient>
        <filter
          id="filter-6"
          width="219.7%"
          height="329.8%"
          x="-59.6%"
          y="-119.7%"
          filterUnits="objectBoundingBox"
        >
          <feOffset in="SourceAlpha" result="shadowOffsetOuter1"></feOffset>
          <feGaussianBlur
            in="shadowOffsetOuter1"
            result="shadowBlurOuter1"
            stdDeviation="4"
          ></feGaussianBlur>
          <feColorMatrix
            in="shadowBlurOuter1"
            result="shadowMatrixOuter1"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          ></feColorMatrix>
          <feMerge>
            <feMergeNode in="shadowMatrixOuter1"></feMergeNode>
            <feMergeNode in="SourceGraphic"></feMergeNode>
          </feMerge>
        </filter>
        <linearGradient
          id="linearGradient-7"
          x1="19.829%"
          x2="-89.972%"
          y1="80.078%"
          y2="186.311%"
        >
          <stop offset="0%" stopColor="#FFF"></stop>
          <stop offset="100%" stopColor="#1E2741"></stop>
        </linearGradient>
      </defs>
      <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
        <g filter="url(#filter-1)" transform="translate(9 9)">
          <g>
            <mask id="mask-3" fill="#fff">
              <use xlinkHref="#path-2"></use>
            </mask>
            <use fill="#FFF" xlinkHref="#path-2"></use>
            <g mask="url(#mask-3)">
              <g transform="translate(2 2)">
                <g fill="none" fillRule="evenodd" strokeWidth="1">
                  <path fill="#FFF" d="M0 0H68V68H0z"></path>
                  <g transform="translate(16.292 9.633)">
                    <path
                      fill="url(#linearGradient-4)"
                      d="M0 0h16.885c6.141 0 11.119 4.978 11.119 11.118 0 6.141-4.978 11.119-11.119 11.119H0V0z"
                    ></path>
                    <path
                      fill="url(#linearGradient-5)"
                      d="M0 20.59h21.416c7.732 0 14 6.268 14 14 0 7.733-6.268 14.002-14 14.002H0V20.59z"
                    ></path>
                  </g>
                  <g
                    fillRule="nonzero"
                    stroke="#FFF"
                    strokeWidth="2.628"
                    filter="url(#filter-6)"
                    transform="translate(15.158 24.367)"
                  >
                    <path d="M.221 15.725c-.087 0-.166-.036-.202-.092-.035-.056-.02-.121.037-.167l9.702-7.604 9.547 3.767L28.909 0l.121.473L19.47 12.05 9.85 8.255.386 15.673a.27.27 0 01-.165.052z"></path>
                  </g>
                </g>
                <circle
                  cx="16.575"
                  cy="38.958"
                  r="1.842"
                  fill="url(#linearGradient-7)"
                  fillRule="nonzero"
                ></circle>
                <circle
                  cx="25.217"
                  cy="32.583"
                  r="1.842"
                  fill="url(#linearGradient-7)"
                  fillRule="nonzero"
                ></circle>
                <circle
                  cx="34.567"
                  cy="36.267"
                  r="1.842"
                  fill="url(#linearGradient-7)"
                  fillRule="nonzero"
                ></circle>
                <circle
                  cx="43.492"
                  cy="24.367"
                  r="1.842"
                  fill="url(#linearGradient-7)"
                  fillRule="nonzero"
                ></circle>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
)
